export default __webpack_public_path__ + "static/media/icon_login3.9515467f.png";